import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import { SOCIAL_LINKS, FOOTER_LINKS_CONFIG } from '../../constants';
import { useLanguage } from '../../hooks/useLanguage';
import logoDsw from '../../assets/logo_dsw2.png';
import '../../styles/components/Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  const iconMap = {
    Facebook,
    Instagram,
    Linkedin,
    Youtube,
  };

  const renderSocialLink = social => {
    const IconComponent = iconMap[social.icon];

    return (
      <a key={social.id} href={social.href} className='social-link'>
        <IconComponent className='social-icon' />
      </a>
    );
  };

  const renderFooterLink = (link, label) => {
    if (link.type === 'route') {
      return (
        <Link key={link.key} to={link.href}>
          {label}
        </Link>
      );
    }
    return (
      <a key={link.key} href={link.href}>
        {label}
      </a>
    );
  };

  return (
    <footer className='footer'>
      <div className='container'>
        <div className='footer-content'>
          <div className='footer-brand'>
            <div className='footer-logo'>
              <img
                src={logoDsw}
                alt='DSW Solutions Logo'
                className='footer-logo-image'
              />
            </div>
            <p className='footer-tagline'>{t.footer.tagline}</p>
            <div className='social-links'>
              {SOCIAL_LINKS.map(renderSocialLink)}
            </div>
          </div>

          {FOOTER_LINKS_CONFIG.map(section => {
            const sectionTexts = t.footer.sections[section.key];
            if (!sectionTexts) return null;
            return (
              <div key={section.key} className='footer-section'>
                <h4 className='footer-title'>{sectionTexts.title}</h4>
                <ul className='footer-links'>
                  {section.links.map(link => {
                    const label = sectionTexts.links[link.key];
                    if (!label) return null;
                    return <li key={link.key}>{renderFooterLink(link, label)}</li>;
                  })}
                </ul>
              </div>
            );
          })}
        </div>

        <div className='footer-divider' />

        <div className='footer-bottom'>
          <p className='copyright'>{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
